import { CalendarViewMode } from "ui/modules/notifications/calendarGrid";

/** Kratice mjeseci za oznaku današnjeg datuma u alatnoj traci. */
export const MONTH_SHORT_NAMES = [
  "SIJ",
  "VELJ",
  "OŽU",
  "TRA",
  "SVI",
  "LIP",
  "SRP",
  "KOL",
  "RUJ",
  "LIS",
  "STU",
  "PRO",
];

export const VIEW_OPTIONS: { value: CalendarViewMode; label: string }[] = [
  { value: "month", label: "Mjesec" },
  { value: "week", label: "Tjedan" },
];

export const DEFAULT_VIEW: CalendarViewMode = "month";
